import React from 'react'

export const MiniFooterLayout = ({ children }) => {
  return <div className="footer">{children}</div>
}
